/**
 * Inspector chrome icon buttons — neutral hover matches `.menu-item:hover` in index.css
 * (`var(--panel-surface-hover)`), not Tailwind `gray-700` (slightly blue-tinted).
 */
export const INSPECTOR_CHROME_NO_FOCUS_RING =
  "outline-none focus:outline-none active:outline-none ring-0 ring-offset-0 focus-visible:ring-2 focus-visible:ring-sky-400/80 focus-visible:ring-offset-1 focus-visible:ring-offset-gray-950";

export const INSPECTOR_CHROME_HOVER_SURFACE = "hover:bg-[var(--panel-surface-hover)]";

export const INSPECTOR_CHROME_ICON_BUTTON_CLASS = [
  "h-7 w-7 shrink-0 inline-flex items-center justify-center rounded-md border-0 bg-transparent p-0 text-gray-200 transition-colors",
  INSPECTOR_CHROME_NO_FOCUS_RING,
  INSPECTOR_CHROME_HOVER_SURFACE,
  "hover:text-gray-100 disabled:opacity-40 disabled:pointer-events-none",
].join(" ");

export const INSPECTOR_CHROME_ICON_DELETE_CLASS = [
  "h-7 w-7 shrink-0 inline-flex items-center justify-center rounded-md border-0 bg-[var(--panel-surface-hover)] p-0 text-white transition-colors",
  INSPECTOR_CHROME_NO_FOCUS_RING,
  "hover:!bg-red-500",
  "disabled:opacity-40 disabled:pointer-events-none",
].join(" ");

/** Upper-right draggable header (joint editor, minimize). */
export const INSPECTOR_CHROME_HEADER_ICON_BUTTON_CLASS = [
  "text-gray-400 px-1.5 py-0.5 rounded cursor-pointer select-none leading-none hover:text-gray-200 transition-colors bg-transparent border-0",
  INSPECTOR_CHROME_NO_FOCUS_RING,
  INSPECTOR_CHROME_HOVER_SURFACE,
].join(" ");

/** Pencil / compact control beside a section title. */
export const INSPECTOR_CHROME_SECTION_ICON_CLASS = [
  "inline-flex items-center justify-center rounded-sm border-0 bg-transparent p-1 -m-0.5 text-gray-200 cursor-pointer transition-colors",
  INSPECTOR_CHROME_NO_FOCUS_RING,
  INSPECTOR_CHROME_HOVER_SURFACE,
  "hover:text-gray-100",
].join(" ");

/**
 * Extra padding above the first row of controls under an inspector collapsible title.
 * `CollapsibleContent` already wraps children with `pt-1`; adding this class once more
 * yields ~8px title-to-content gap (between the old tight-only and `pt-2` stacks).
 */
export const INSPECTOR_SECTION_TITLE_TO_BODY_PAD_CLASS = "pt-1";
